@if (visible()) {
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4 backdrop-blur-sm"
    (click)="dismiss.emit()">
    <div
      class="relative w-full max-w-sm rounded-2xl bg-white p-8 shadow-2xl"
      [dir]="isArabic ? 'rtl' : 'ltr'"
      (click)="$event.stopPropagation()">
      <button
        type="button"
        (click)="dismiss.emit()"
        class="absolute top-4 cursor-pointer text-gray-400 transition-colors hover:text-gray-600"
        [class.right-4]="!isArabic"
        [class.left-4]="isArabic">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>

      <h3 class="mb-2 text-base font-bold text-gray-900" i18n="@@product.cancel.title">Cancel Action</h3>
      <p class="mb-8 text-sm leading-relaxed text-gray-500" i18n="@@product.cancel.message">
        Are you sure you want to cancel this action?
      </p>

      <div class="flex gap-3" [class.justify-end]="!isArabic" [class.justify-start]="isArabic">
        <button
          type="button"
          (click)="confirm.emit()"
          class="bg-primary hover-bg-primary-hover cursor-pointer rounded-lg px-6 py-2.5 text-sm font-bold text-white transition"
          i18n="@@product.cancel.yes">
          Yes, Cancel
        </button>
        <button
          type="button"
          (click)="dismiss.emit()"
          class="cursor-pointer rounded-lg border border-gray-200 px-6 py-2.5 text-sm font-semibold text-gray-600 transition hover:bg-gray-50"
          i18n="@@product.cancel.no">
          No
        </button>
      </div>
    </div>
  </div>
}
